import { NgIf } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { FormControl } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { RecipesTranslationFieldsContainerComponent } from '@recipes/recipes-translation/recipes-translation-fields-container/recipes-translation-fields-container.component';
import { RecipesTranslationInputFieldsComponent } from '@recipes/recipes-translation/recipes-translation-input-fields/recipes-translation-input-fields.component';
import {
  RecipesTranslationSectionComponent,
  TranslationLang,
} from '@recipes/recipes-translation/recipes-translation-section/recipes-translation-section.component';

@Component({
  selector: 'app-recipes-translation-tips',
  templateUrl: './recipes-translation-tips.component.html',
  imports: [
    RecipesTranslationSectionComponent,
    RecipesTranslationFieldsContainerComponent,
    RecipesTranslationInputFieldsComponent,
    NgIf,
    TranslateModule,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RecipesTranslationTipsComponent {
  @Input() lang: TranslationLang;
  @Input() sourceTipsControl: FormControl<string>;
  @Input() targetTipsControl: FormControl<string>;
}
